module.exports = __webpack_public_path__ + "img/20.f873c936.png";